import { render, staticRenderFns } from "./sailingWithSkipper.vue?vue&type=template&id=2642e490&scoped=true"
import script from "./sailingWithSkipper.vue?vue&type=script&lang=js"
export * from "./sailingWithSkipper.vue?vue&type=script&lang=js"
import style0 from "./sailingWithSkipper.vue?vue&type=style&index=0&id=2642e490&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2642e490",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VImg: require('/var/www/tubber-new/components/global/v/img.vue').default,VBreadcrumbs: require('/var/www/tubber-new/components/global/v/breadcrumbs.vue').default,VButton: require('/var/www/tubber-new/components/global/v/button.vue').default})
